export default __webpack_public_path__ + "static/media/more-vertical.639acd34.svg";